import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { diyProcesses } from '@/data/diyProcesses';

// Import all the individual DIY process components
import AffidavitsDeclarations from './diy/AffidavitsDeclarations';
import StatusCorrectionPassport from './diy/StatusCorrectionPassport';
import TaxLiabilityRemoval from './diy/TaxLiabilityRemoval';
import TrustEstateEstablishment from './diy/TrustEstateEstablishment';
import ForeignTrustEIN from './diy/ForeignTrustEIN';

import PrivateTransportationAuthority from './diy/PrivateTransportationAuthority';


// Import components needed for 404 page
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const DIYProcessPage = () => {
  const { processId } = useParams<{ processId: string }>();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const processData = diyProcesses.find(process => process.id === processId);

  if (!processData) {
    return (
      <div className="min-h-screen">
        <Header />
        <main className="pt-32 pb-20 bg-background">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-4">
              Process Not Found
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              The DIY process you're looking for doesn't exist.
            </p>
            <Link to="/diy-processes">
              <Button variant="outline" className="flex items-center gap-2">
                <ArrowLeft className="h-4 w-4" />
                Back to DIY Processes
              </Button>
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  // Render the appropriate component based on the process ID
  switch (processId) {
    case 'affidavits-declarations':
      return <AffidavitsDeclarations />;
    case 'status-correction-passport':
      return <StatusCorrectionPassport />;
    case 'tax-liability-removal':
      return <TaxLiabilityRemoval />;
    case 'trust-estate-establishment':
      return <TrustEstateEstablishment />;
    case 'foreign-trust-ein':
      return <ForeignTrustEIN />;
    case 'private-transportation-authority':
      return <PrivateTransportationAuthority />;
    default:
      return (
        <div className="min-h-screen">
          <Header />
          <main className="pt-32 pb-20 bg-background">
            <div className="max-w-6xl mx-auto px-4 text-center">
              <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-4">
                Process Not Found
              </h1>
              <p className="text-xl text-muted-foreground mb-8">
                The DIY process you're looking for doesn't exist.
              </p>
              <Link to="/diy-processes">
                <Button variant="outline" className="flex items-center gap-2">
                  <ArrowLeft className="h-4 w-4" />
                  Back to DIY Processes
                </Button>
              </Link>
            </div>
          </main>
          <Footer />
        </div>
      );
  }
};

export default DIYProcessPage;